import { TextField } from "@mui/material";
import moment from "moment";
import React from "react";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ReactSelect from "react-select";
import dayjs from "dayjs";
// import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

// Extend dayjs with the plugins
dayjs.extend(utc);
dayjs.extend(timezone);


// Extend dayjs with utc
dayjs.extend(utc);

export const Input = ({
  value,
  onChange,
  className,
  label,
  error,
  extraErr = false,
  required,
  optional,
  loading,
  leftIcon,
  optionalText,
  condition = false,
  ...rest
}) => {
  // console.log(condition, "Condition")
  const classGenerator = () => {
    if (extraErr && condition) {
      return "is-invalid";
    }
    if (error && !value) {
      return "is-invalid";
    }
  };

  return (
    <>
      {label && (
        <label className="my-1 text-dark">
          {label}
          {required && <span className="text-danger"> *</span>}
          {optional && <span className="text-secondary"> (optional)</span>}
          {optionalText && (
            <span className="text-secondary"> {optionalText}</span>
          )}
        </label>
      )}

      <input
        value={value}
        onChange={onChange}
        className={`${className} ${classGenerator()}`}
        // className={`${className} ${!value && error ? "is-invalid" : error ? "is-invalid" : ""}`}
        {...rest}
        loading={loading ? "" : ""}
      />
      {leftIcon}
      {error && <div className="invalid-feedback">{error}</div>}
    </>
  );
};

export const Select = ({
  label,
  onChange,
  value,
  error,
  className,
  children,
  required,
  loading,
  ...rest
}) => {
  return (
    <>
      {label && <label className="my-1 text-dark">{label}</label>}
      {required && <span className="text-danger"> *</span>}
      <select
        onChange={onChange}
        value={value}
        className={`${className} ${!value && error && "is-invalid"}`}
        {...rest}
        loading={loading ? "" : ""}
      >
        {children}
      </select>
      {error && <div className="invalid-feedback">{error}</div>}
    </>
  );
};

//-------------text-Area-input-field--------------------
export const TextArea = ({
  value,
  onChange,
  label,
  className,
  error,
  required,
  loading,
  optionalText,
  extraErr = false,
  condition = false,
  ...rest
}) => {
  const classGenerator = () => {
    if (extraErr) {
      return "is-invalid";
    }
    if (error && !value) {
      return "is-invalid";
    }
  };
  return (
    <>
      {label && <label className="my-1">{label}</label>}
      {required && <span className="text-danger"> *</span>}
      {optionalText && <span className="text-secondary"> {optionalText}</span>}
      <textarea
        value={value}
        onChange={onChange}
        // className={`${className} ${!value && error && "is-invalid"}`}
        className={`${className} ${classGenerator()}`}
        {...rest}
        loading={loading ? "" : ""}
      />
      {error && <div className="invalid-feedback">{error}</div>}
    </>
  );
};
//-------------react-date-picker--------------------
export const DatePicker = ({
  label,
  required,
  placeholder,
  error,
  className,
  name,
  selected,
  onChange,
  maxDate,
  minDate,
  ...rest
}) => {
  return (
    <>
      {label && <label className="col-form-label">{label}</label>}
      {required && <span className="text-danger"> *</span>}

      <ReactDatePicker
        placeholderText={placeholder}
        className={`${className} ${!selected && error && "is-invalid"}`}
        name={name}
        // {selected?isClearable:showIcon}
        // isClearable
        // showIcon
        isClearable={selected ? true : false}
        showIcon={!selected ? true : false}
        showYearDropdown
        autoComplete="off"
        yearDropdownItemNumber={10}
        scrollableYearDropdown
        showMonthDropdown
        useShortMonthInDropdown
        selected={selected ? new Date(selected) : null}
        onChangeRaw={(e) => e.preventDefault()}
        onChange={(date) =>
          onChange(date) ? (date) => onChange(date) : onChange
        }
        dateFormat="dd-MM-yyyy"
        maxDate={maxDate ? new Date(maxDate) : Date.now()}
        minDate={minDate ? new Date(minDate) : null}
        {...rest}
      />
      {error && (
        <p className={`invalid-feedback ${!selected && "d-block"}`}>{error}</p>
      )}
    </>
  );
};
//-------------react-select--------------------
export const ReactSelector = ({
  name,
  className,
  value,
  error,
  option,
  multi = false,
  onChange,
  label,
  placeholder,
}) => {
  // console.log(value, "Value");
  return (
    <>
      {label && <label className="mb-1">{label}</label>}
      <ReactSelect
        name={name}
        value={value}
        className={`${className} ${!value?.value && error && "is-invalid"}`}
        options={option}
        isMulti={multi}
        placeholder={placeholder}
        isClearable={value?.value ? true : false}
        onChange={onChange}
      />
      {error && <div className={`invalid-feedback`}>{error}</div>}
      {/*   */}
    </>
  );
};

//-------------react-date-picker-input-field------------------
export const DatePickerInput = ({
  label,
  required,
  placeholder,
  error,
  className,
  name,
  selected,
  onChange,
  maxDate,
  minDate,
  ...rest
}) => {
  return (
    <>
      {label && <label className="col-form-label">{label}</label>}
      {required && <span className="text-danger"> *</span>}

      <ReactDatePicker
        placeholderText={placeholder}
        className={`${className} ${!selected && error && "is-invalid"}`}
        name={name}
        // {selected?isClearable:showIcon}
        // isClearable
        // showIcon
        isClearable={selected ? true : false}
        showIcon={!selected ? true : false}
        showYearDropdown
        yearDropdownItemNumber={10}
        scrollableYearDropdown
        showMonthDropdown
        useShortMonthInDropdown
        selected={selected ? new Date(selected) : null}
        onChangeRaw={(e) => e.preventDefault()}
        onChange={(date) =>
          onChange(date) ? (date) => onChange(date) : onChange
        }
        dateFormat="dd-MM-yyyy"
        maxDate={maxDate ? new Date(maxDate) : null}
        minDate={minDate ? new Date(minDate) : null}
        {...rest}
      />
      {error && (
        <p className={`invalid-feedback ${!selected && "d-block"}`}>{error}</p>
      )}
    </>
  );
};
//----------------date-format-----------------------
export const dateFormat = (date) => {
  return date ? moment(date).format("DD-MM-yyyy") : "N/A";
};

export const dateMonthFormat = (date) => {
  return date ? moment(date).format("DD MMM yyyy") : "N/A";
};
export const timeFormat = (time) => {
  return time ? moment(time, "HH:mm").format("h:mm A") : "N/A";
};
export const dateTime = (time) => {
  return time ? dayjs.utc(time).format("ddd, DD MMM, h:mm a") : "N/A";
};
// export const onlyTime = (time) => {
//   return time ? dayjs.utc(time).format("h:mm A") : "N/A";
// };
export const onlyTime = (time, timeZone = "UTC") => {
  return time ? dayjs.utc(time).tz(timeZone).format("h:mm A") : "N/A";
};

export const dayAndDate = (date) => {
  return date ? dayjs.utc(date).format("ddd, DD MMM") : "N/A";
};




export const formatDateTime = (scheduleDate, scheduleTime) => {
  const date = new Date(scheduleDate);

  // Format date to "Thu, 19 Sep"
  const formattedDate = date.toLocaleDateString("en-US", {
    weekday: "short",
    day: "numeric",
    month: "short",
  });

  // Check if scheduleTime is defined and in the correct format
  if (scheduleTime && typeof scheduleTime === "string") {
    const [hours, minutes] = scheduleTime.split(":"); // Assuming time is in "HH:MM:SS" format
    if (hours && minutes) {
      const time = new Date();
      time.setHours(hours, minutes);

      // Format the time to "5:30 am/pm"
      const formattedTime = time.toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      });

      return `${formattedDate}, ${formattedTime}`;
    }
  }

  // If scheduleTime is undefined or in an invalid format, return just the date
  return formattedDate;
};
export const searchDateFormat = (date) => {
  // return date ? moment(date).format("DD-MM-yyyy") : ""
  return date ? moment(date).format("yyyy-MM-DD") : "";
};
//----------chat-time-format-------------
export const chatTimeFormat = (time) => {
  if (!time) return "N/A";

  const givenDate = dayjs(time);
  const today = dayjs();

  if (givenDate.isSame(today, "day")) {
    return givenDate.format("h:mm a");
  } else {
    return givenDate.format("MMM D, YYYY h:mm a");
  }
};
//---------time-format-with-second------------
export const timeFormatWithSecond = (time) => {
  console.log(time,"time")
  return time ? moment(time).local().format("HH:mm:ss") : "N/A";
};

//-----------money-converter-format-----------------
const formatter = new Intl.NumberFormat("en-US", {
  style: "currency", // Specify the style as currency
  currency: "USD", // Specify the currency as USD (U.S. Dollar)
});
// Format the totalRevenue as currency
export const cashConverter = (money) => {
  return formatter.format(money);
};
//------------capitalize-First-Letter------------
export const capitalizeFirstLetter = (str) => {
  if (str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }
  return "";
};

//-----------mui-input-field-----------------

export const MuiInput = ({
  label,
  placeholder,
  onChange,
  name,
  value,
  className,
  error,
}) => {
  return (
    <TextField
      fullWidth
      label={label}
      className={`${className} ${!value && error && "is-invalid"}`}
      name={name}
      value={value}
      placeholder={placeholder}
      variant="outlined"
      onChange={onChange}
      error={error}
    />
  );
};

//-----------convert-text-to-href-link----and-hasTags-#---and-emoji---------------------------
// Function to replace custom markdown and URLs
export const formatContent = (content) => {
  // Replace custom markdown patterns
  let formattedContent = content
    ? content.replace(/#\[(\w+)\]\(undefined\)/g, "#$1")
    : "";

  // Replace URLs with anchor tags
  const urlRegex = /((https?:\/\/|www\.)[^\s]+)/g;
  formattedContent = formattedContent.replace(urlRegex, (url) => {
    let hyperlink = url;
    if (!hyperlink.startsWith("http")) {
      hyperlink = "http://" + hyperlink;
    }
    return `<a href="${hyperlink}" target="_blank" rel="noopener noreferrer">${url}</a>`;
  });

  return formattedContent;
};
